import React from 'react';
import './SummaryCard.css';

const SummaryCard = ({ title, value, icon: IconComponent, color }) => {
  return (
    <div className="summary-card" style={{ borderTopColor: color }}>
      <div className="summary-card-content">
        <div className="summary-card-info">
          <h3 className="summary-card-title">{title}</h3>
          <p className="summary-card-value">{value}</p>
        </div>
        <div className="summary-card-icon" style={{ backgroundColor: color + '20', color: color }}>
          {IconComponent && <IconComponent size={28} />}
        </div>
      </div>
    </div>
  );
};

export default SummaryCard;
